import React from "react";

const AB_IMG = `${import.meta.env.BASE_URL}img/andar-bahar-cards`;
const CARD_KEYS = Array.from({ length: 13 }, (_, i) => i + 1);

/**
 * Andar Bahar 50 / 150 cards (ab3 / ab4) bet area in the reference markup (inside .casino-detail):
 *   .ab-bg > .andar-cards-box.text-center[.suspended] + .bahar-cards-box.text-center[.suspended]
 *     > h5.w-100.text-center.text-playera|b + 13 × .casino-card-item
 *       (.text-center = child[i].l · .card-image > img andar-bahar-cards/{1..13 | 0}.png · .casino-book)
 * Reference data: `main` = feed `child` with subtype = game type (A..K Andar, then A..K Bahar),
 * `odds` = feed `sub` with visible 1. Andar is suspended when there is no visible market, it is
 * SUSPENDED or its sid is even; Bahar when it is SUSPENDED.
 * Card image: {n}.png when l > 0 and b == 1, otherwise 0.png. The reference admin never shows a
 * book under the cards: always 0, bets or not.
 */
export default function AbBetTable({ gameType, child = [], sub = [], onBetClick }) {
  const main = (Array.isArray(child) ? child : []).filter((c) => c?.subtype === gameType);
  const odds = (Array.isArray(sub) ? sub : []).filter((s) => Number(s?.visible) === 1);
  const o = odds[0];
  const andarSuspended = odds.length === 0 || o?.gstatus === "SUSPENDED" || Number(o?.sid) % 2 === 0;
  const baharSuspended = o?.gstatus === "SUSPENDED";

  const box = (side, offset, suspended) => (
    <div className={`${side === "andar" ? "andar" : "bahar"}-cards-box text-center${suspended ? " suspended" : ""}`}>
      <h5 className={`w-100 text-center text-player${side === "andar" ? "a" : "b"}`}>
        {`\n                                    ${side === "andar" ? "Andar" : "Bahar"}\n                                `}
      </h5>{" "}
      {CARD_KEYS.map((n, i) => {
        const m = main[i + offset];
        const face = Number(m?.l) > 0 && Number(m?.b) === 1;
        return (
          <div
            key={`${side}-${i}`}
            className="casino-card-item"
            onClick={() => !suspended && onBetClick?.(o?.b, m?.nat, null, m)}
          >
            <div className="text-center">{m?.l}</div>{" "}
            <div className="card-image">
              <img src={`${AB_IMG}/${face ? n : 0}.png`} alt="" />
            </div>{" "}
            <div className="casino-book">0</div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="ab-bg">
      {box("andar", 0, andarSuspended)}{" "}
      {box("bahar", 13, baharSuspended)}
    </div>
  );
}
